import { styled } from '@nextiva/next-ui-components';

export const GroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-8px',
  padding: '0px 15px',
  backgroundColor: theme.palette.primary.light,
}));
